import { Stack } from '@mui/material';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';

import React from 'react';
import * as ds from './dataService';
import { SaveProduct_Input } from 'generated/graphql';



export type SaveProductFormProps = {
  id?: string;
  installationId?: string;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveProductFormProps) => {
  const [
    fnSaveForm,
    { loading }
  ] = ds.useSaveProductForm();


  const form = ds.useFormState(props.id ?? '', props.installationId ?? '');

  const handleSubmit = async () => {
    const input: SaveProduct_Input = {
      ...form.formState
    };
    await fnSaveForm(input);
    props.handleClose();
  };
  const fields: (keyof ds.IFormState)[] = [
    'name',
    'supplier',
    'manufacturer',
    'model',
    'hardware',
    'finish',
    'notes'
  ];
  return (
    <FormBaseLayout.FC
      handleCancel={() => {
        props.handleClose();
      }}
      handleSubmit={() => handleSubmit()}
      cancelButtonText='Cancel'
      isLoading={loading}
    >
      <Stack
        rowGap='1.25rem'
      >
        {fields.map((field, i) => (
          <StyledTextField.FC
            key={i}
            {...form.genFieldProps(field)}
          />
        ))}
      </Stack>
    </FormBaseLayout.FC>
  );
};
